module.exports = __webpack_public_path__ + "img/inquire.fe1b44c9.png";